export class CostReviewFln {
  numberOfVfds!: number;
  productName!: string;
  otherFlnMstpDevices!: string;
  networkType!: number[];
}
